import { call } from "redux-saga/effects";


let getMobileRestrictionStatusDataForGestionsModule = null;
export function* getMobileRestrictionStatusDataForGestions({
    productId,
    phoneType,
    phone,
  }) {
  if(!getMobileRestrictionStatusDataForGestionsModule){
    getMobileRestrictionStatusDataForGestionsModule = yield call(() => import('./get-mobile-restriction-status-data-for-gestions'))
  }
  yield call(
    getMobileRestrictionStatusDataForGestionsModule.getMobileRestrictionStatusDataForGestions,
    {
      productId,
      phoneType,
      phone,
    }
  )
  // llamada a modulo
}
let changeMobileRestrictionDataForGestionsModule = null;
export function* changeMobileRestrictionDataForGestions({
  productId,
  restriction,
  action,
  id=null,
  target,
  phone,
  msgs,
  phoneType,
}) {
  if(!changeMobileRestrictionDataForGestionsModule){
    changeMobileRestrictionDataForGestionsModule = yield call(() => import('./change-mobile-restriction-data-for-gestions'))
  }
  yield call(
    changeMobileRestrictionDataForGestionsModule.changeMobileRestrictionDataForGestions,
    {
      productId,
      restriction,
      action,
      id,
      target,
      phone,
      msgs,
      phoneType
    }
  )
  // llamada a modulo
}
let getMyProductsDataModule = null;
export function* getMyProductsData({ handlingCode = 0 }) {
  if(!getMyProductsDataModule){
    getMyProductsDataModule = yield call(() => import('./get-my-products-data'))
  }
  yield call(
    getMyProductsDataModule.getMyProductsData,
    { handlingCode }
  )
  // llamada a modulo
}

let getMyProductsDataModuleWithoutCache = null;
export function* getMyProductsDataWithoutCache({ handlingCode = 0 }) {
  if(!getMyProductsDataModuleWithoutCache){
    getMyProductsDataModuleWithoutCache = yield call(() => import('./get-my-products-without-cache'))
  }
  yield call(
    getMyProductsDataModuleWithoutCache.getMyProductsDataWithoutCache,
    { handlingCode }
  )
  // llamada a modulo
}

let getPukByLineModule = null;
export function* getPukByLine({ productId, handlingCode = 0 }) {
  if(!getPukByLineModule){
    getPukByLineModule = yield call(() => import('./get-puk'))
  }
  yield call(
    getPukByLineModule.getPukCode,
    { productId, handlingCode }
  )
  // llamada a modulo
}

let myProductRenttorentModule = null;
export function* myProductRenttorent({ typeR2R }) {
  if(!myProductRenttorentModule){
    myProductRenttorentModule = yield call(() => import('./my-product-renttorent'))
  }
  yield call(
    myProductRenttorentModule.myProductRenttorent,
    { typeR2R }
  )
  // llamada a modulo
}
let getMyLineDetailMobileRestrictionStatusDataModule = null;
export function* getMyLineDetailMobileRestrictionStatusData({ data }) {
  if (!getMyLineDetailMobileRestrictionStatusDataModule) {
    getMyLineDetailMobileRestrictionStatusDataModule = yield call(() =>
      import("./get-my-line-detail-mobile-restriction-status-data")
    );
  }
  yield call(
    getMyLineDetailMobileRestrictionStatusDataModule.getMyLineDetailMobileRestrictionStatusData,
    { data }
  );
  // llamada a modulo
}

let getMobileConfigurationStatusDataModule = null;
export function* getMobileConfigurationStatusData({ phone, tipo }) {
  if (!getMobileConfigurationStatusDataModule) {
    getMobileConfigurationStatusDataModule = yield call(() =>
      import("./get-mobile-configuration-status-data")
    );
  }
  yield call(
    getMobileConfigurationStatusDataModule.getMobileConfigurationStatusData,
    { phone, tipo }
  );
  // llamada a modulo
}

let changeMobileConfigurationDataModule = null;
export function* changeMobileConfigurationData({
    phone,
    diversionToChange,
    diversionPhone,
  }) {
  if (!changeMobileConfigurationDataModule) {
    changeMobileConfigurationDataModule = yield call(() =>
      import("./change-mobile-configuration-data")
    );
  }
  yield call(
    changeMobileConfigurationDataModule.changeMobileConfigurationData,
    {
      phone,
      diversionToChange,
      diversionPhone,
    }
  );
  // llamada a modulo
}

let getMobileRestrictionStatusDataModule = null;
export function* getMobileRestrictionStatusData({
    productId,
    phoneType,
    phone,
  }) {
  if (!getMobileRestrictionStatusDataModule) {
    getMobileRestrictionStatusDataModule = yield call(() =>
      import("./get-mobile-restriction-status-data")
    );
  }
  yield call(
    getMobileRestrictionStatusDataModule.getMobileRestrictionStatusData,
    {
      productId,
      phoneType,
      phone,
    }
  );
  // llamada a modulo
}

let changeMobileRestrictionDataModule = null;
export function* changeMobileRestrictionData({action, id,    phoneType,    productId,    restriction}) {
  if (!changeMobileRestrictionDataModule) {
    changeMobileRestrictionDataModule = yield call(() =>
      import("./change-mobile-restriction-data")
    );
  }
  yield call(
    changeMobileRestrictionDataModule.changeMobileRestrictionData,
    {
      action, id,    phoneType,    productId,    restriction
    }
  );
  // llamada a modulo
}

let getEquipmentProductsModule = null;
export function* getEquipmentProducts() {
  if (!getEquipmentProductsModule) {
    getEquipmentProductsModule = yield call(() =>
      import("./get-equipment-products")
    );
  }
  yield call(
    getEquipmentProductsModule.getEquipmentProducts
  );
  // llamada a modulo
}

let getActivateLineDataModule = null;
export function* getActivateLineData({ handlingCode = 0 }) {
  if (!getActivateLineDataModule) {
    getActivateLineDataModule = yield call(() =>
      import("./get-activate-line-data")
    );
  }
  yield call(
    getActivateLineDataModule.getActivateLineData,
    { handlingCode }
  );
  // llamada a modulo
}

let postActivarSegundaFibraModule = null;
export function* postActivarSegundaFibra(data) {
  if (!postActivarSegundaFibraModule) {
    postActivarSegundaFibraModule = yield call(() =>
      import("./post-activar-segunda-fibra")
    );
  }
  yield call(
    postActivarSegundaFibraModule.postActivarSegundaFibra,
    data
  );
  // llamada a modulo
}

let postDesactivarSegundaFibraModule = null;
export function* postDesactivarSegundaFibra(data) {
  if (!postDesactivarSegundaFibraModule) {
    postDesactivarSegundaFibraModule = yield call(() =>
      import("./post-desactivar-segunda-fibra")
    );
  }
  yield call(
    postDesactivarSegundaFibraModule.postDesactivarSegundaFibra,
    data
  );
  // llamada a modulo
}

let getSellingTypesByProductIdsModule = null;
export function* getSellingTypesByProductIds(data) {
  if (!getSellingTypesByProductIdsModule) {
    getSellingTypesByProductIdsModule = yield call(() =>
      import("./get-selling-types-by-product-ids")
    );
  }
  yield call(
    getSellingTypesByProductIdsModule.getSellingTypesByProductIds,
    data
  );
  // llamada a modulo
}

let getEsimStatusModule = null;
export function* getEsimStatus({ handlingCode = 0, productId, typeEsim, status }) {
  if(!getEsimStatusModule){
    getEsimStatusModule = yield call(() => import('./get-esim-status'))
  }
  yield call(
    getEsimStatusModule.getEsimStatus,
    { handlingCode,productId, typeEsim, status }
  )
  // llamada a modulo
}

let getEsimDownloadModule = null;
export function* getEsimDownload({  resourceId }) {
  if(!getEsimDownloadModule){
    getEsimDownloadModule = yield call(() => import('./get-esim-download'))
  }
  yield call(
    getEsimDownloadModule.getEsimDownload,
    { resourceId }
  )
  // llamada a modulo
}

let setEsimStatusModule = null;
export function* setEsimStatus({esimStatus, resourceDataSelected }) {
  if(!setEsimStatusModule){
    setEsimStatusModule = yield call(() => import('./set-esim-status'))
  }
  yield call(
    setEsimStatusModule.setEsimStatus,
    { esimStatus, resourceDataSelected }
  )
  // llamada a modulo
}

let getAllMyProductsR2RModule = null;
export function* getAllMyProductsR2R() {
  if (!getAllMyProductsR2RModule) {
    getAllMyProductsR2RModule = yield call(() => import('./get-my-products-r2r-info'))
  }
  yield call(
    getAllMyProductsR2RModule.getMyProductsR2R
  )
}

let getUpgradeEquipmentModule = null;
export function* getUpgradeEquipment(cards) {
  if (!getUpgradeEquipmentModule) {
    getUpgradeEquipmentModule = yield call(() => import('./upgrade-equipment'))
  }
  yield call(
    getUpgradeEquipmentModule.getUpgradeEquipment,
    { cards }
  )
}

let getFTTRProductRenttorentModule = null;
export function* getFTTRProductRenttorentInfo({ typeR2R }) {
  if(!getFTTRProductRenttorentModule){
    getFTTRProductRenttorentModule = yield call(() => import('./get-fttr-r2r-data'))
  }
  yield call(
    getFTTRProductRenttorentModule.myFTTRProductRenttorent,
    { typeR2R }
  )
  // llamada a modulo
}